import { render, staticRenderFns } from "./AddressChangeRequest.vue?vue&type=template&id=143f21d3&scoped=true"
import script from "./AddressChangeRequest.vue?vue&type=script&lang=js"
export * from "./AddressChangeRequest.vue?vue&type=script&lang=js"
import style0 from "./AddressChangeRequest.vue?vue&type=style&index=0&id=143f21d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f21d3",
  null
  
)

export default component.exports